import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const WORKSHEET_ANALYZE_BUTTON_QUERY = gql`
  query WorksheetAnalyzeButtonQuery($id: StrictString!) @skipAudit @engComponent(name: NOTEBOOK) {
    worksheet(id: $id) {
      ... on WorksheetNode {
        id
        name
        folder {
          id
        }
        studies {
          ... on StudyNode {
            id
            name
            humanId
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const WORKSHEET_ANALYZE_BUTTON_PROCEDURE_METHOD_QUERY = gql`
  query WorksheetAnalyzeButtonProcedureMethodQuery($methodExecutionInstanceId: StrictString!)
  @skipAudit
  @engComponent(name: NOTEBOOK) {
    procedureMethodExecutionInstance(id: $methodExecutionInstanceId) {
      ... on ProcedureMethodExecutionInstanceNode {
        id
        procedureRun {
          id
          procedureType
          study {
            ... on StudyNode {
              id
              studySchema {
                id
                studyType
              }
            }
            ... on InaccessibleInfoNode {
              ...InaccessibleInfoGraphQL
            }
          }
        }
        planMethodDefinitionVersion {
          ... on ProcedurePlanMethodDefinitionVersionNode {
            id
            analysisTemplateConfigurations {
              ... on ProcedureAnalysisTemplateConfigurationNode {
                analysisTemplate {
                  id
                  name
                  archiveRecord {
                    purpose
                  }
                }
                configJson
              }
              ... on InaccessibleInfoNode {
                ...InaccessibleInfoGraphQL
              }
            }
          }
          ...InaccessibleInfoGraphQL
        }
      }
      ... on InaccessibleInfoNode {
        ...InaccessibleInfoGraphQL
      }
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
